import React from 'react';

import List from 'component/Search/Filter/Active/List';

import { ActiveFilter, FilterAction } from 'proto/Search/ActiveFilter';

import ToggleButton from './__partials/ToggleButton';

interface ToggleBarProps {
    activeFilterList: ActiveFilter[];
    onFilterClick?: (actionList: FilterAction[], filterIndex: number) => void;
    onResetAllClick?: () => void;
}

const ToggleBar = ({
    activeFilterList,
    onFilterClick,
    onResetAllClick,
}: ToggleBarProps) =>
    activeFilterList.length ? (
        <ToggleButton filterCount={activeFilterList.length}>
            <List
                activeFilterList={activeFilterList}
                onFilterClick={onFilterClick}
                onResetAllClick={onResetAllClick}
            />
        </ToggleButton>
    ) : null;

export default ToggleBar;
